import React from "react";

const EmptyStateMenu = () => {
  return (
    <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
      <img
        src={require("../../assets/images/empty-state.png")}
        alt="services"
        width={"30%"}
        loading="lazy"
        className="img-fluid images-gray"
      />
      <p className="font-vietnam-300 text-center">
        Oops! The page you are looking for does not exist. <br />
        It might have been moved or deleted.
      </p>
    </div>
  );
};

export default EmptyStateMenu;
